module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kd-Lc.aed9ecee.png";